module.exports = __webpack_public_path__ + "img/article-daily-share-ok.2481fc30.png";